import mixin from "../../../../mixins/mixin";
import messageService from "../../../../services/message";
import Vue from "vue";

export default {
  data() {
    return {
      loading: false,
      messagesSms: [],
      message: {},
    };
  },
  components: {
    NotificationContent: require("../../../bookings/details/modals/NotificationContentModal"),
  },
  mixins: [mixin],
  async mounted() {
    let vm = this;
    Vue.filter("getDateForSmsMessage", function (date) {
      if (!date) {
        return "N/A";
      }
      let months = vm.$t("months");
      let res = new Date(date);
      return (
        res.getDate() +
        " " +
        months[res.getMonth()] +
        " " +
        res.getFullYear() +
        " " +
        res.getHours() +
        ":" +
        (res.getMinutes() > 9 ? res.getMinutes() : "0" + res.getMinutes())
      );
    });

    await messageService.getSmsSent(vm);
  },
  methods: {
    viewMessage(text) {
      this.message = {
        message: text,
      };
      this.openModal("#view-auto-action-modal");
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/account/sms-info/index/index.js